import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  Avatar,
  Fade,
} from "@mui/material";
import Navbar from "../../components/navbar/NavBar";
import Footer from "../../components/navbar/Footer";

const AboutPage = () => {
  const team = [
    {
      name: "Er. Santos Pudasaini",
      role: "Senior Vastu Expert",
      description: "5+ years of experience in Vastu Shastra consulting",
      image: "/api/placeholder/150/150",
    },
    {
      name: "Nikesh Sapkota",
      role: "Tech Lead",
      description:
        "Manage the development of VastuPlan's innovative Vastu analysis system",
      image: "/api/placeholder/150/150",
    },
    {
      name: "Shabd Mishra",
      role: "Full Stack Developer",
      description:
        "Specializes in developing scalable web applications for VastuPlan",
      image: "/api/placeholder/150/150",
    },
  ];

  return (
    <Box
      sx={{
        background: "#ffffff",
        minHeight: "100vh",
        color: "#333333",
      }}
    >
      <Navbar />

      <Container sx={{ pt: 15, pb: 8 }}>
        <Fade in timeout={1000}>
          <Grid container spacing={6}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h2"
                component="h1"
                gutterBottom
                sx={{
                  color: "#bb0000",
                  fontWeight: 700,
                  position: "relative",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    bottom: -8,
                    left: 0,
                    width: "80px",
                    height: "4px",
                    background: "#bb0000",
                    borderRadius: "2px",
                  },
                }}
              >
                About VastuPlan
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mb: 4,
                  color: "#666666",
                  fontWeight: 300,
                }}
              >
                Where Ancient Wisdom Meets Modern Technology
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: "1.1rem",
                  lineHeight: 1.8,
                  color: "#555555",
                }}
              >
                At Vastuplan, we merge ancient Vedic wisdom with modern Vastu
                approaches to deliver personalized reports quickly. Our
                innovative system allows users to log in and receive a
                comprehensive Vastu report in minutes—empowering you to create a
                balanced, harmonious living environment without the wait.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.1rem",
                  lineHeight: 1.8,
                  color: "#555555",
                }}
              >
                We believe that harmony in living spaces translates to harmony
                in life. Our team works together to make Vastu principles
                accessible to everyone, anywhere in the world.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 20,
                    left: 20,
                    right: -20,
                    bottom: -20,
                    background: "rgba(187, 0, 0, 0.1)",
                    borderRadius: 4,
                    zIndex: 0,
                  },
                }}
              >
                <Box
                  component="img"
                  src="https://res.cloudinary.com/duaz5kg1m/image/upload/v1739271189/dgau8mp7vukxlrsmymcn.jpg"
                  alt="About VastuPlan"
                  sx={{
                    width: "100%",
                    borderRadius: 4,
                    position: "relative",
                    zIndex: 1,
                    boxShadow: "0 20px 40px rgba(187, 0, 0, 0.1)",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Fade>

        <Box sx={{ mt: 12 }}>
          <Typography
            variant="h3"
            component="h2"
            textAlign="center"
            gutterBottom
            sx={{
              mb: 8,
              color: "#bb0000",
              position: "relative",
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: -16,
                left: "50%",
                transform: "translateX(-50%)",
                width: "60px",
                height: "4px",
                background: "#bb0000",
                borderRadius: "2px",
              },
            }}
          >
            Our Values
          </Typography>
          <Grid container spacing={4}>
            {[
              {
                title: "Authenticity",
                description:
                  "We stay true to traditional Vastu principles while making them relevant for modern living.",
              },
              {
                title: "Innovation",
                description:
                  "We leverage technology to make Vastu consultation more accurate and accessible.",
              },
              {
                title: "Excellence",
                description:
                  "We strive for perfection in every analysis and recommendation we provide.",
              },
            ].map((value) => (
              <Grid item xs={12} md={4} key={value.title}>
                <Card
                  sx={{
                    background: "#ffffff",
                    borderRadius: 4,
                    p: 4,
                    height: "100%",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                    border: "1px solid rgba(187, 0, 0, 0.1)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 20px 40px rgba(187, 0, 0, 0.1)",
                      borderColor: "rgba(187, 0, 0, 0.3)",
                    },
                  }}
                >
                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{ color: "#bb0000" }}
                  >
                    {value.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: "#555555" }}>
                    {value.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mt: 12 }}>
          <Typography
            variant="h3"
            component="h2"
            textAlign="center"
            gutterBottom
            sx={{
              mb: 8,
              color: "#bb0000",
              position: "relative",
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: -16,
                left: "50%",
                transform: "translateX(-50%)",
                width: "60px",
                height: "4px",
                background: "#bb0000",
                borderRadius: "2px",
              },
            }}
          >
            Meet Our Team
          </Typography>
          <Grid container spacing={4}>
            {team.map((member) => (
              <Grid item xs={12} md={4} key={member.name}>
                <Card
                  sx={{
                    background: "#ffffff",
                    borderRadius: 4,
                    p: 4,
                    textAlign: "center",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                    border: "1px solid rgba(187, 0, 0, 0.1)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 20px 40px rgba(187, 0, 0, 0.1)",
                      borderColor: "rgba(187, 0, 0, 0.3)",
                    },
                  }}
                >
                  <Avatar
                    src={member.image}
                    sx={{
                      width: 120,
                      height: 120,
                      mx: "auto",
                      mb: 3,
                      border: "4px solid rgba(187, 0, 0, 0.1)",
                      boxShadow: "0 8px 20px rgba(187, 0, 0, 0.1)",
                    }}
                  />
                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{ color: "#bb0000" }}
                  >
                    {member.name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{ color: "#666666", mb: 2 }}
                  >
                    {member.role}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#555555" }}>
                    {member.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default AboutPage;
